/**
 * [T-058] API ของ staff desktop จาก T-057 (merge แล้ว #90):
 * - GET /api/v1/tickets/counts?team_id= — ตัวเลขข้างเมนู sidebar (triage = null เมื่อ flag ปิด)
 * - POST /api/v1/tickets/bulk — action เป็นชุด ยิงครั้งเดียว ตอบผลรายใบ
 * ทั้งคู่ degrade เมื่อ endpoint ยังไม่มี (404/422): ซ่อนตัวเลข / ปิดปุ่ม bulk — ห้าม fallback ยิงทีละใบ
 */
import { queryOptions } from "@tanstack/react-query";
import type { BulkTicketAction, BulkTicketResult, TicketCounts } from "@uwu/contracts";
import { api, isApiError, qs } from "./api";

export type { TicketCounts } from "@uwu/contracts";

/** 404/422 = endpoint ยังไม่มี (T-057 ยังไม่ merge) → ซ่อนฟีเจอร์ที่พึ่งพามัน */
export function isStaffApiMissing(e: unknown): boolean {
  return isApiError(e, 404) || isApiError(e, 422);
}

export const staffKeys = {
  counts: (teamId?: string) => ["staff", "counts", teamId ?? null] as const,
};

/** ตัวเลขเมนู — retry: false เพื่อให้ error (404) ไปถึง UI เร็ว แล้วซ่อนตัวเลขเงียบ ๆ */
export const ticketCountsQuery = (teamId?: string) =>
  queryOptions({
    queryKey: staffKeys.counts(teamId),
    queryFn: () => api.get<TicketCounts>("/api/v1/tickets/counts" + qs({ team_id: teamId })),
    staleTime: 30_000,
    retry: false,
  });

/** action/ผลลัพธ์ของ bulk — ใช้สัญญากลางจาก @uwu/contracts (T-057) */
export type BulkAction = BulkTicketAction;
export type BulkResponse = BulkTicketResult;

/** ยิงครั้งเดียวเท่านั้น — ห้ามวนยิงทีละใบ (กฎของใบงาน) */
export function postBulk(ids: string[], action: BulkAction): Promise<BulkResponse> {
  return api.post<BulkResponse>("/api/v1/tickets/bulk", { ids, action });
}
